import { StateSetter } from 'react';

import { mutations } from 'entities';

import { Box, Button } from 'components/Blocks';

import { getFormConfig } from 'components/Form';

import { v } from 'utils/validation';
import { ArrowLeftIcon, LockIcon } from 'components/Blocks/Icons';
import { useLang } from 'locale';
import { navigateToLogin } from 'providers/Auth';

const emailStep = getFormConfig({
  email: v.common.email(),
});

export function EmailStep({ onEmail }: { onEmail: StateSetter<string> }) {
  const { t } = useLang();

  const forgotPW = mutations.auth.forgotPassword.use({
    onSuccess: (_, params) => onEmail(params.email),
  });

  return (
    <emailStep.Form onSubmit={forgotPW.execute}>
      <Box className="mx-auto bg-primary/20 p-2 text-primary" border="circle">
        <LockIcon size={18} />
      </Box>

      <h1 className="text-2xl text-foreground-title phone:text-xl">{t('forgot-password')}</h1>

      <p className="mx-auto max-w-[80%] text-foreground-light phone:max-w-full">
        {t('forgot-password-instructions')}
      </p>

      <emailStep.Input property="email" label={t('email')} fullWidth containerClassName="mt-4" />

      <emailStep.SubmitButton className="mt-2 h-auto py-2">{t('send')}</emailStep.SubmitButton>

      <Button variant="link" className="text-foreground-title" onClick={navigateToLogin}>
        <ArrowLeftIcon />
        {t('back-to-login')}
      </Button>
    </emailStep.Form>
  );
}
